// extracted by mini-css-extract-plugin
export default {"container":"Minesweeper_container__UeMKl","header":"Minesweeper_header__Bqkop","body":"Minesweeper_body__q6Pt0"};